import axios from "axios";
import { store } from "./redux/store/store";
import { setCurrentUser } from "./redux/user/user.actions";

/**
 * Keys the app treats as "this tab is signed in".
 *
 * Sign-in writes each of these to both localStorage and sessionStorage, and
 * signing out clears both, so localStorage is the durable copy and
 * sessionStorage is the per-tab working copy.
 */
const SESSION_KEYS = ["token", "is_guest", "guest_user", "machineId"];

/**
 * Gives a newly opened tab the session the user already has.
 *
 * The route guard reads sessionStorage, which is scoped to a single tab. A tab
 * opened fresh — "open in new tab" on any link, or the Business Hub opened in
 * business mode — therefore started with no token and bounced straight to the
 * login screen even though the user was signed in.
 *
 * Copying the durable localStorage copy into this tab's sessionStorage fixes
 * that everywhere, and cannot revive a closed session: signing out clears
 * localStorage too, so there is nothing left to copy.
 */
const hydrateTabSession = () => {
  try {
    SESSION_KEYS.forEach((key) => {
      if (sessionStorage.getItem(key)) return; // this tab already has it
      const durable = localStorage.getItem(key);
      if (durable) sessionStorage.setItem(key, durable);
    });
  } catch (e) {
    /* private mode with storage blocked — the guard will ask for a login */
  }
};

export const initAuthSession = () => {
  hydrateTabSession();

  const token = localStorage.getItem("token");
  const isGuest = localStorage.getItem("is_guest");
  if (token) return;

  if (isGuest) {
    const guestUser = JSON.parse(localStorage.getItem("guest_user"));
    if (guestUser) {
      store.dispatch(setCurrentUser(guestUser));
    }
  }
};
